import { Row } from 'antd'
import styled from 'styled-components'

export const AirTravelerRow = styled(Row)`
  margin-top: 16px;
`

export const AirTravelerRowName = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`

export const AirTravelerRowInfo = styled.div`
  display: grid;
  padding-left: 16px;
`
